import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import NavBar from './components/NavBar';
import Socials from './components/Socials';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Listen from './pages/Listen';
import About from './pages/About';
import './styles/styles.scss';
import Collaborators from './pages/Collaborators';
import Live from './pages/Live';
import Press from './pages/Press';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div className='page'>
        <NavBar />
        <main className='main'>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/index" element={<App />} />
            <Route path="/index.html" element={<App />} />
            <Route path="/live" element={<Live />} />
            <Route path="/listen" element={<Listen />} />
            <Route path="/about" element={<About />} />
            <Route path="/press" element={<Press />} />
            <Route path="/collaborators" element={<Collaborators />} />
          </Routes>
        </main>
        <Socials />
      </div>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
